import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Reloj Biológico',
    items: ['Activa tu hábito natural cada mañana', 'Recuperá tu reflejo intestinal en 5 minutos', 'Aprovechá la ventana mágica de 6 a 9 AM', 'Despertá tu sistema desde la cama', 'Plan claro de 21 días, día por día'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — Hidratación Osmótica',
    items: ['Hidratá de verdad, no solo tomes agua', 'El trío que ablanda todo desde adentro', '5 infusiones argentinas que destraban', 'Las grasas que lubrican sin engordar', 'Bebidas correctas en cada momento del día'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — La Escoba Inteligente',
    items: ['Adiós a la fibra que te infla', '12 alimentos que barren sin gas', 'Sabé qué fibra inflama y cuál no', 'Mejorá sin sufrir más hinchazón', 'Recetas simples que mueven todo'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Ingeniería de la Evacuación',
    items: ['El banquito que cambia todo en 1 día', 'Soltá sin empujar y sin dolor', 'Cuidá tu suelo pélvico mientras vas', 'Masaje simple que destraba al toque', 'Posturas que aceleran la salida'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — Libertad Diaria',
    items: ['Nunca más volvés al punto cero', 'Libertad social sin recaer', 'Viajá tranquila, sin miedo al baño', 'Manejá ciclo y menopausia con calma', 'Mantenimiento de 3 minutos por día'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan diario listo para aplicar desde el primer día', 'Técnicas adaptadas a ingredientes de la feria y farmacia argentina', 'Checklist de los 7 puntos de verificación diaria', 'Tracker de progreso para medir la mejora semana a semana', 'Errores frecuentes y cómo evitarlos', 'Preguntas frecuentes respondidas directamente', 'Bibliografía científica en cada tomo'];
  return <section className="py-24 bg-brand-dark" data-id="element-240">
      <div className="container mx-auto px-4" data-id="element-241">
        <div className="max-w-5xl mx-auto" data-id="element-242">
          <div className="text-center mb-16" data-id="element-243">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-244">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-245">
                SISTEMA DESPERTAR LIVIANA™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-246">
                5 Tomos + 5 Bonos — Plan de 21 días
              </p>
              <p className="text-xl text-brand-light mb-2" data-id="element-247">
                El primer sistema de 4 pilares para el estreñimiento crónico,
                100% adaptado a Argentina
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-248">
            📚 5 TOMOS COMPLETOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-249">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-250">
                <div className="text-5xl shrink-0" data-id="element-251">{tomo.emoji}</div>
                <div data-id="element-252">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-253">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-254">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-255">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-256" />
                        <span data-id="element-257">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-258">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-259">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-260">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-261">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-262" />
                  <span className="text-gray-200" data-id="element-263">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}